// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__17pBK","CloseButton":"modal_CloseButton__BH1pn","OptionsButton":"modal_OptionsButton__1iV7r","Button":"modal_Button__UFnFX"};